import { FormUtils } from '../../FormUtils';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MessageService } from '../../services/message.service';
import { CardholderDetails } from '../../data/CardholderDetails';
import { Identity } from '../../Identity';
import { ShipService } from '../../services/ship.service';
import { Ship } from '../../Ship';
import { BulkTransfersService } from '../../services/bulk-transfers.service';
import { CardholderPersonalInfo } from '../../data/CardholderPersonalInfo';
import { NCConstants } from '../../data/NCConstants';
import * as customValidator from '../../validators/cardholder-validator';
import * as customContactAddress from '../../validators/contact-address-validator';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { UserEmail } from '../../data/UserEmail';
import { NCCustomerAccounts } from '../../data/NCCustomerAccounts';
import { Address } from '../../data/Address';
import { Card } from '../../data/Card';
import { MerchantService } from '../../services/merchant.service';
import { Merchant } from '../../Merchant';
import { User } from '../../User';
import {countryCodes} from '../../country-codes';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit {
  cardholder: ProfileSearchResult;
  cardholdersLocationForm: UntypedFormGroup;
  cardholderPersonalInfoForm: UntypedFormGroup;
  save_location_btn: boolean;
  save_btn: boolean;
  isEscrow: boolean;
  save_location_btn_spinner: string;
  save_btn_spinner: string;
  identity: Identity;
  profiles: Ship[] = [];
  meus: Map<string, Set<string>> = new Map<string, Set<string>>();
  mmeus: Map<string, string> = new Map<string, string>();
  status: string;
  message: string;
  cardholderPersonalInfo: CardholderPersonalInfo;
  countries = countryCodes;
  maxDate: NgbDate = this.calendar.getToday();
  chipOnly: boolean;
  cardsAccount: Card[];
  user: User;
  merchants: Merchant[] = [];

  serviceStatuses: string[] = ['N/A', 'KIA', 'MIA', 'WIA', 'POW'];
  shipLoc: string;

  get personalInfoControls() {
    return this.cardholderPersonalInfoForm.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private shipService: ShipService,
    private merchantService: MerchantService,
    private calendar: NgbCalendar,
    private bulkTransfersService: BulkTransfersService,
    private formUtils: FormUtils,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.loadPageData();
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadPageData();
  }

  loadPageData() {
    this.identity = new Identity();
    this.shipService.getShipProfiles().subscribe(
      (data: Ship[]) => {
        this.profiles = data;
      },
      (error) => {
        this.messageService.error(error.error);
      }
    );

    if (this.hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE')) {
      this.bulkTransfersService.getMeusMmeus().subscribe(
        (data) => {
          this.meus = data.mmeus;
          const listMeus: string[] = Object.keys(this.meus);
          const otherList: string[] = Object.values(this.meus);
          for (const meu of listMeus) {
            this.mmeus.set(meu, otherList[listMeus.indexOf(meu)].toString());
          }
        },
        (error) => {
          console.log(error.error);
        }
      );
    }

    this.cardHolderService
      .getCardholdersPersonalInfo(this.cardholder.payrollAccount)
      .subscribe(
        (data: CardholderPersonalInfo) => {
          this.cardholderPersonalInfo = data;

          if (
            this.cardholderPersonalInfo.nCCustomerAccounts.serviceStatus == null
          ) {
            this.cardholderPersonalInfo.nCCustomerAccounts.serviceStatus =
              'N/A';
          }

          // This is to make sure there is an email object for
          // the form to function properly
          if (this.cardholderPersonalInfo.secondaryEmail == null) {
            this.cardholderPersonalInfo.secondaryEmail = new UserEmail();
          }

          this.cardHolderService
            .getCardholderDetails(this.cardholder.payrollAccount)
            .subscribe(
              (details: CardholderDetails) => {
                this.identity = details.identity;
                this.cardsAccount = details.cardList;
                (<UntypedFormGroup>this.cardholdersLocationForm).patchValue(
                  { meu: this.identity.meu },
                  { onlySelf: true }
                );
                this.initFormData();
              },
              (error) => {
                this.messageService.error(error.message);
              },
              () => {
                this.checkChipOnly();
                this.cardHolderService.chipDetails(this.chipOnly);
              }
            );
        },
        (error) => {
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.data);
          } else {
            this.messageService.error(error.message);
          }
        }
      );

    this.initForms();
  }

  initForms() {
    this.status = '';
    this.save_btn_spinner = '';
    this.save_btn = false;

    this.cardholdersLocationForm = this.formBuilder.group({
      location: ['', []],
      meu: ['', []]
    });

    this.cardholderPersonalInfoForm = this.formBuilder.group({
      payGrade: [null, [Validators.required]],
      militaryBranch: [null, [Validators.required]],
      firstName: [
        null,
        [
          Validators.required,
          Validators.maxLength(30),
          customValidator.cardholderNameValidator
        ]
      ],
      lastName: [
        null,
        [
          Validators.required,
          Validators.maxLength(30),
          customValidator.cardholderNameValidator
        ]
      ],
      middleName: [
        null,
        [Validators.maxLength(30), customValidator.cardholderNameValidator]
      ],
      dob: [null, [Validators.required]],
      mothersMaidenName: [
        null,
        [
          Validators.required,
          Validators.maxLength(30),
          customValidator.cardholderNameValidator
        ]
      ],
      socialSecurity: [
        null,
        [
          Validators.maxLength(9),
          Validators.pattern(/^(\*{5}[0-9]{4}|[0-9]{9})$/)
        ]
      ],
      primaryEmail: [null, [Validators.email, Validators.required]],
      secondaryEmail: [null, [Validators.email, Validators.required]],
      dayPhone: [null, [Validators.pattern(/^\d{10,15}$/)]],
      evePhone: [null, [Validators.pattern(/^\d{10,15}$/), Validators.required]],
      addressLine1: [null, [Validators.required]],
      addressLine2: [null, []],
      addressLine3: [null, []],
      city: [
        null,
        [
          Validators.required,
          Validators.maxLength(34),
          customContactAddress.cityValidator
        ]
      ],
      state: [null, [Validators.required]],
      zip: [
        null,
        [
          Validators.required,
          Validators.maxLength(10),
          customContactAddress.zipValidator
        ]
      ],
      country: [
        null,
        [
          Validators.required
        ]
      ],
      dutyAddressLine1: [null, []],
      dutyAddressLine2: [null, []],
      dutyAddressLine3: [null, []],
      dutyCity: [
        null,
        [Validators.maxLength(34), customContactAddress.cityValidator]
      ],
      dutyState: [null, []],
      dutyZip: [
        null,
        [Validators.maxLength(10), customContactAddress.zipValidator]
      ],
      dutyCountry: [null,[]],
      serviceStatus: [null, []],
      dateLetterSent: [null, []],
      dateLetterReturned: [null, []]
    });

    this.cardholderPersonalInfoForm
      .get('dob')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.cardholderPersonalInfoForm
            .get('dob')
            .setValidators([
              Validators.required,
              customValidator.dobValidator(value)
            ]);
        }
      });

    this.cardholderPersonalInfoForm
      .get('dutyAddressLine1')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.cardholderPersonalInfoForm
            .get('dutyCity')
            .setValidators([
              Validators.required,
              Validators.maxLength(34),
              customContactAddress.cityValidator
            ]);
          this.cardholderPersonalInfoForm
            .get('dutyZip')
            .setValidators([
              Validators.required,
              Validators.maxLength(10),
              customContactAddress.zipValidator
            ]);
          this.cardholderPersonalInfoForm
            .get('dutyState')
            .setValidators(Validators.required);
          this.cardholderPersonalInfoForm
            .get('dutyCountry')
            .setValidators(Validators.required);
          this.cardholderPersonalInfoForm
            .get('dutyCity')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyState')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyZip')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyCountry')
            .updateValueAndValidity();
        } else {
          this.cardholderPersonalInfoForm.get('dutyCity').clearValidators();
          this.cardholderPersonalInfoForm.get('dutyState').clearValidators();
          this.cardholderPersonalInfoForm.get('dutyZip').clearValidators();
          this.cardholderPersonalInfoForm.get('dutyCountry').clearValidators();
          this.cardholderPersonalInfoForm
            .get('dutyCity')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyState')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyZip')
            .updateValueAndValidity();
          this.cardholderPersonalInfoForm
            .get('dutyCountry')
            .updateValueAndValidity();
        }
      });

    this.cardholderPersonalInfoForm
      .get('dutyCity')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .setValidators(Validators.required);
        } else {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .clearValidators();
        }
      });

    this.cardholderPersonalInfoForm
      .get('dutyState')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .setValidators(Validators.required);
        } else {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .clearValidators();
        }
      });

    this.cardholderPersonalInfoForm
      .get('dutyZip')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .setValidators(Validators.required);
        } else {
          this.cardholderPersonalInfoForm
            .get('dutyAddressLine1')
            .clearValidators();
        }
      });

    this.cardholderPersonalInfoForm
      .get('dutyCountry')
      .valueChanges.subscribe((value) => {
      if (value) {
        this.cardholderPersonalInfoForm
          .get('dutyAddressLine1')
          .setValidators(Validators.required);
      } else {
        this.cardholderPersonalInfoForm
          .get('dutyAddressLine1')
          .clearValidators();
      }
    });

    if(this.cardholder.enrollmentType === 'F' || this.cardholder.enrollmentType === 'M' || this.cardholder.enrollmentType === 'C'){
      this.cardholderPersonalInfoForm.get('mothersMaidenName').clearValidators();
      this.cardholderPersonalInfoForm.get('payGrade').clearValidators();
      this.cardholderPersonalInfoForm.get('militaryBranch').clearValidators();
      this.cardholderPersonalInfoForm.get('socialSecurity').clearValidators();
      this.cardholderPersonalInfoForm.get('addressLine1').clearValidators();
      this.cardholderPersonalInfoForm.get('city').clearValidators();
      this.cardholderPersonalInfoForm.get('state').clearValidators();
      this.cardholderPersonalInfoForm.get('country').clearValidators();
      this.cardholderPersonalInfoForm.get('zip').clearValidators();
      this.cardholderPersonalInfoForm.get('secondaryEmail').clearValidators();
      this.cardholderPersonalInfoForm.get('mothersMaidenName').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('socialSecurity').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('addressLine1').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('city').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('state').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('country').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('zip').updateValueAndValidity();
      this.cardholderPersonalInfoForm.get('secondaryEmail').updateValueAndValidity();
    }
  }

  initFormData() {
    this.cardholdersLocationForm.patchValue({
      location: this.identity.currentShip.shipLocation
    });

    this.cardholderPersonalInfoForm.patchValue({
      payGrade: this.identity.payGrade,
      militaryBranch: this.identity.militaryBranch,
      firstName: this.identity.firstName,
      lastName: this.identity.lastName,
      middleName: this.identity.middleName,
      dob: this.cardholderPersonalInfo.dateOfBirth,
      mothersMaidenName: this.identity.mothersMaidenName,
      socialSecurity: this.identity.socialSecurity,
      primaryEmail: this.cardholderPersonalInfo.primaryEmail
        ? this.cardholderPersonalInfo.primaryEmail.emailAddr
        : '',
      secondaryEmail: this.cardholderPersonalInfo.secondaryEmail
        ? this.cardholderPersonalInfo.secondaryEmail.emailAddr
        : '',
      dayPhone: this.cardholderPersonalInfo.userPhone.dayPhone,
      evePhone: this.cardholderPersonalInfo.userPhone.evePhone,
      addressLine1: this.cardholderPersonalInfo.address.addressLine1,
      addressLine2: this.cardholderPersonalInfo.address.addressLine2,
      addressLine3: this.cardholderPersonalInfo.address.addressLine3,
      city: this.cardholderPersonalInfo.address.city,
      state: this.cardholderPersonalInfo.address.state,
      zip: this.cardholderPersonalInfo.address.zip,
      country: this.cardholderPersonalInfo.address.country
    });

    if (this.cardholderPersonalInfo.dutyAddress) {
      this.cardholderPersonalInfoForm.patchValue({
        dutyAddressLine1: this.cardholderPersonalInfo.dutyAddress.addressLine1,
        dutyAddressLine2: this.cardholderPersonalInfo.dutyAddress.addressLine2,
        dutyAddressLine3: this.cardholderPersonalInfo.dutyAddress.addressLine3,
        dutyCity: this.cardholderPersonalInfo.dutyAddress.city,
        dutyState: this.cardholderPersonalInfo.dutyAddress.state,
        dutyZip: this.cardholderPersonalInfo.dutyAddress.zip,
        dutyCountry: this.cardholderPersonalInfo.dutyAddress.country
      });
    }

    if (
      this.cardholderPersonalInfo.nCCustomerAccounts &&
      this.cardholderPersonalInfo.nCCustomerAccounts.serviceStatus != null
    ) {
      let newDateLetterSent: NgbDate = null;
      let newDateLetterReturned: NgbDate = null;

      if (this.cardholderPersonalInfo.nCCustomerAccounts.dateLetterSent) {
        const dateLetterSentWork =
          this.cardholderPersonalInfo.nCCustomerAccounts.dateLetterSent;
        const dateLetterSentWorkDate = new Date(dateLetterSentWork);
        newDateLetterSent = new NgbDate(
          dateLetterSentWorkDate.getFullYear(),
          dateLetterSentWorkDate.getMonth() + 1,
          dateLetterSentWorkDate.getDate()
        );
      }
      if (this.cardholderPersonalInfo.nCCustomerAccounts.dateLetterReturned) {
        const dateLetterReturnedWork =
          this.cardholderPersonalInfo.nCCustomerAccounts.dateLetterReturned;
        const dateLetterReturnedWorkDate = new Date(dateLetterReturnedWork);
        newDateLetterReturned = new NgbDate(
          dateLetterReturnedWorkDate.getFullYear(),
          dateLetterReturnedWorkDate.getMonth() + 1,
          dateLetterReturnedWorkDate.getDate()
        );
      }
      this.cardholderPersonalInfoForm.patchValue({
        serviceStatus:
          this.cardholderPersonalInfo.nCCustomerAccounts.serviceStatus,
        dateLetterSent: newDateLetterSent,
        dateLetterReturned: newDateLetterReturned
      });
    }
  }

  get dobErrorMessage(): string {
    // Get the first error message from the DOB controller
    const errorCode = Object.keys(this.personalInfoControls['dob'].errors)[0];
    return customValidator.dobValidationErrorMessage(errorCode);
  }

  get contactCityErrorMessage(): string {
    return customContactAddress.cityValidatorMessage();
  }

  get contactZipErrorMessage(): string {
    return customContactAddress.zipValidatorMessage();
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  saveLocation() {
    if (
      this.identity.militaryBranch !== 'MARINES' &&
      this.cardholdersLocationForm.controls['location'].value ===
        this.cardholderPersonalInfo.identity.currentShip.shipLocation
    ) {
      this.messageService.error('No Location Change');
      return;
    }

    this.save_location_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_location_btn = true;

    let meuParm: string = null;
    if (this.identity.militaryBranch === 'MARINES') {
      meuParm = this.cardholdersLocationForm.controls['meu'].value;
    }

    this.cardHolderService
      .saveLocation(
        this.cardholder.payrollAccount,
        this.cardholdersLocationForm.controls['location'].value,
        meuParm,
        this.identity.idSeq
      )
      .subscribe(
        () => {
          if (this.identity.meu !== meuParm)
          {
            this.identity.meu = meuParm;
          }
          this.messageService.success('Saved Successfully');
          this.save_location_btn_spinner = '';
          this.save_location_btn = false;
        },
        (error) => {
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.error);
          } else {
            this.messageService.error(error.message);
          }
          this.save_location_btn_spinner = '';
          this.save_location_btn = false;
        }
      );

    this.merchantService
      .getAccountableOfficialsMerchants(
        this.cardholder.socialSecurity.substr(5, 8),
        this.cardholderPersonalInfo.identity.firstName,
        this.cardholderPersonalInfo.identity.lastName
      )
      .subscribe(
        (data: Merchant[]) => {
          this.merchants = data;
        },
        () => {},
        () => {
          for (let merchant of this.merchants) {
            this.merchantService
              .saveAccountableOfficial(
                0,
                merchant.ncMerchantNum,
                merchant.location
              )
              .subscribe(
                () => {},
                (error) => {
                  if (error.error) {
                    this.messageService.error(error.error);
                  }
                }
              );
          }
        }
      );
  }

  createUpdateObject(): CardholderPersonalInfo {
    // create new copy of the personal information and identity
    const personalInfo: CardholderPersonalInfo = JSON.parse(
      JSON.stringify(this.cardholderPersonalInfo)
    );

    const controls = this.personalInfoControls;

    personalInfo.identity.payGrade = controls['payGrade'].value;
    personalInfo.identity.militaryBranch = controls['militaryBranch'].value;
    personalInfo.identity.firstName = controls['firstName'].value;
    personalInfo.identity.lastName = controls['lastName'].value;
    personalInfo.identity.middleName = controls['middleName'].value;
    personalInfo.identity.mothersMaidenName =
      controls['mothersMaidenName'].value;
    if (!personalInfo.primaryEmail && controls['primaryEmail'].value) {
      personalInfo.primaryEmail = <UserEmail>{};
    }
    personalInfo.primaryEmail.emailAddr = controls['primaryEmail'].value;
    if (!personalInfo.secondaryEmail && controls['secondaryEmail'].value) {
      personalInfo.secondaryEmail = <UserEmail>{};
    }
    personalInfo.secondaryEmail.emailAddr = controls['secondaryEmail'].value;
    personalInfo.userPhone.dayPhone = controls['dayPhone'].value;
    personalInfo.userPhone.evePhone = controls['evePhone'].value;
    personalInfo.address.addressLine1 = controls['addressLine1'].value;
    personalInfo.address.addressLine2 = controls['addressLine2'].value;
    personalInfo.address.addressLine3 = controls['addressLine3'].value;
    personalInfo.address.city = controls['city'].value;
    personalInfo.address.state = controls['state'].value;
    personalInfo.address.zip = controls['zip'].value;
    personalInfo.address.country = controls['country'].value;

    if (
      !personalInfo.dutyAddress &&
      controls['dutyAddressLine1'].value != null
    ) {
      personalInfo.dutyAddress = <Address>{};
      personalInfo.dutyAddress.addressLine1 =
        controls['dutyAddressLine1'].value;
      personalInfo.dutyAddress.addressLine2 =
        controls['dutyAddressLine2'].value;
      personalInfo.dutyAddress.addressLine3 =
        controls['dutyAddressLine3'].value;
      personalInfo.dutyAddress.city = controls['dutyCity'].value;
      personalInfo.dutyAddress.state = controls['dutyState'].value;
      personalInfo.dutyAddress.zip = controls['dutyZip'].value;
      personalInfo.dutyAddress.country = controls['dutyCountry'].value;
    }

    if (controls['socialSecurity'].value !== '') {
      personalInfo.identity.socialSecurity = controls['socialSecurity'].value;
    }

    if (controls['dob'].value != null && controls['dob'].value !== '') {
      personalInfo.dateOfBirth = controls['dob'].value;
    }

    if (
      controls['dateLetterSent'].value != null &&
      controls['dateLetterSent'].value !== undefined
    ) {
      const sentDate: NgbDate = controls['dateLetterSent'].value;
      if (!personalInfo.nCCustomerAccounts) {
        personalInfo.nCCustomerAccounts = <NCCustomerAccounts>{};
      }
      personalInfo.nCCustomerAccounts.dateLetterSent = new Date(
        sentDate.year,
        sentDate.month - 1,
        sentDate.day
      ).getTime();
    }

    if (
      controls['dateLetterReturned'].value != null &&
      controls['dateLetterReturned'].value !== undefined
    ) {
      const returnDate: NgbDate = controls['dateLetterReturned'].value;
      if (!personalInfo.nCCustomerAccounts) {
        personalInfo.nCCustomerAccounts = <NCCustomerAccounts>{};
      }
      personalInfo.nCCustomerAccounts.dateLetterReturned = new Date(
        returnDate.year,
        returnDate.month - 1,
        returnDate.day
      ).getTime();
    }

    if (
      controls['serviceStatus'].value != null &&
      controls['serviceStatus'].value
    ) {
      if (!personalInfo.nCCustomerAccounts) {
        personalInfo.nCCustomerAccounts = <NCCustomerAccounts>{};
      }
      personalInfo.nCCustomerAccounts.serviceStatus =
        controls['serviceStatus'].value;

      if (personalInfo.nCCustomerAccounts.serviceStatus === 'N/A') {
        personalInfo.nCCustomerAccounts.serviceStatus = null;
        personalInfo.nCCustomerAccounts.serviceStatusDate = null;
      }
    }

    return personalInfo;
  }

  savePersonalInfo() {
    this.formUtils.markFormFieldsAsTouched(this.cardholderPersonalInfoForm);
    if (!this.cardholderPersonalInfoForm.valid) {
      return;
    }
    this.save_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_btn = true;
    const personalInfo: CardholderPersonalInfo = this.createUpdateObject();

    this.cardHolderService
    this.cardHolderService
      .savePersonal(this.cardholder.payrollAccount, personalInfo)
      .subscribe(
        (data) => {
          this.messageService.success('Saved Successfully');
          this.message = data['message'];
          this.status = data['status'];
          this.save_btn_spinner = '';
          this.save_btn = false;
          this.loadPageData();
        },
        (error) => {
          this.save_btn_spinner = '';
          this.save_btn = false;
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.error);
          } else {
            this.messageService.error(error.message);
          }
        }
      );
  }

  showEnrollmentForm() {
    this.cardHolderService
      .downloadEnrollmentPDF(
        this.identity.idSeq,
        this.identity.formSeq,
        null
      )
      .subscribe(
        (data) => {
          const pdfFile = new Blob([data], { type: 'application/pdf' });
          const pdfURL = URL.createObjectURL(pdfFile);
          window.open(pdfURL);
        },
        (error) => this.messageService.error(error.message)
      );
  }

  reloadSettlementHistory() {}

  checkChipOnly() {
    const index = this.cardsAccount.findIndex((x) => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }

  getNewFormSeq() {
    this.cardHolderService.getMaxFormSeqForIdentity(this.identity.idSeq)
      .subscribe(
        (newFormSeq) => {
          this.identity.formSeq = newFormSeq;
          this.cdr.detectChanges()
        }
      );
  }
  filterMeus(location) {
    const listMeus: string[] = [];

    this.mmeus.forEach((value, key) => {
      if (value === location || !location.includes('MLG00')) {
        listMeus.push(key.toString());
      }
    });
    return listMeus;
  }

  changeMeu(inMeu) {
    const location = inMeu.target.value;
    if (location.includes('MLG00')) {
      for (const [key, value] of this.mmeus.entries()) {
        if (value !== location) {
          continue;
        }
        const isShipToMLGTransfer = !this.identity.currentShip.shipLocation.includes('MLG00') && key.charAt(0) === this.identity.meu.charAt(0);

        if (!isShipToMLGTransfer) {
          this.cardholdersLocationForm.get('meu').setValue(key);
        }
        break;
      }
    }
  }
}
